export const LOGIN_FAILED = 'Login failed, Incorrect username or password';
export const SIGNUP_FAILED = 'Signup failed!';
export const USER_ALREADY_SIGNED_UP = 'User already signed up!';
export const FAILED_SESSION_RETRIEVAL = 'Could not retrieve session';
